import styled from '@emotion/styled'
import { FormControl, InputBase, InputLabel } from '@mui/material'

import { Tooltip } from 'packages/eid-ui'
import React, { useState } from 'react'

const StyledInput = styled(InputBase)(({ theme }) => ({
    borderRadius: '0.4rem',
    position: 'relative',
    fontSize: '1.5rem',
    padding: '0 0 0 1rem',
    fieldSizing: 'content',
    '&:-ms-input-placeholder': {
        opacity: `${1} !important`,
        color: '#b4b4b4 !important',
    },
    focused: {
        backgroundColor: theme?.palette?.common?.white,
    },
}))

const InputWithInnerLabel = ({
    label,
    placeholder,
    value,
    handleChange,
    validationError = null,
    errorMessage = '',
    disabled = false,
    showTooltip = false,
    ...rest
}) => {
    const [showErrors, setShowErrors] = useState(false)
    return (
        <FormControl
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                padding: '1.2rem',
                backgroundColor: (theme) =>
                    `${theme?.palette?.background?.paper} !important`,
                border: 'solid 1px #ebebed',
                transition: 'border 0.15s ease-in-out 0s',
                '&:focus-within': {
                    borderColor: (theme) => theme?.palette?.primary?.main,
                },
                ...(showErrors &&
                    validationError && {
                        '& input': {
                            border: 'solid 1px red !important',
                        },
                        '& label': {
                            color: 'red !important',
                        },
                    }),
                ...(Boolean(errorMessage) && {
                    border: '1px solid #d0021b !important',
                }),
                ...(disabled && {
                    '& .Mui-disabled': {
                        WebkitTextFillColor: '#5d6870',
                    },
                }),
            }}
        >
            {label && (
                <InputLabel
                    style={{
                        textTransform: 'uppercase',
                        color: '#b4b4b4',
                        position: 'inherit',
                        fontSize: '1.2rem',
                        transform: 'none',
                    }}
                >
                    {label}
                </InputLabel>
            )}
            <Tooltip title={showTooltip && value ? value : ''}>
                <StyledInput
                    value={value}
                    onChange={handleChange}
                    onBlur={() => {
                        if (!value) {
                            setShowErrors(true)
                        } else {
                            setShowErrors(false)
                        }
                    }}
                    disabled={disabled}
                    {...rest}
                />
            </Tooltip>
        </FormControl>
    )
}

export default InputWithInnerLabel
